import { get } from 'lodash'

export default {
  'EARLY-DECISION-CONTRACT': (user) => {
    return get(user, 'DocumentRequirements.NeedsToSignEarlyDecisionContract', false)
  },
}
